import React from 'react';
import email from '../../../assets/images/mail.svg';
import Image from '../../atoms/Image/Image';
const EmailAddress =()=>{
    return(
        <>
            <div className='contact-info'>
                <figure><Image src={email} alt="Location" /></figure>
                <div>
                    <h3 className='h4'>Email</h3>
                    <p className='mb-0'><a href="mailto:car.reservations@europcar.in" className='contact-email' >car.reservations@europcar.in</a></p>
                </div>
            </div>
           
        </>
    )
}
export default EmailAddress